import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .loadingLottie {
    width: 300px;
    height: 300px;
  }
`;
